import { TournamentState } from '@ps/web-poker-tile-mappers';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import useTimer from '@swf/core/hooks/useTimer';
import { getSafeMilliseconds, getTimeDiff, getTimeFormatPropsFromTimeDiff } from '@swf/poker';

import { usePokerSundayMillionWidget } from '../../../model';

const EventTimer: React.FC = () => {
  const { widgetSelect } = usePokerSundayMillionWidget();
  const state = useSelector(widgetSelect.getTournament)?.formattedState;
  const timerDate = useSelector(widgetSelect.getTimerDate);
  const startDate = useSelector(widgetSelect.getTournament)?.whenStartInt;
  const date = state === TournamentState.LATE_REGISTRATION ? startDate : timerDate ?? '';
  const timeInMilliseconds = getSafeMilliseconds(date);
  const timer = useTimer({ initial: timeInMilliseconds });
  const times = getTimeDiff(Date.now(), timer);

  const { translation, values } = getTimeFormatPropsFromTimeDiff(times);
  return <Translation {...translation} values={values} />;
};

export default EventTimer;
